import { useCurrentUserContext } from 'contexts/currentUser';

export const useEnergyBalance = () => {
  const { currentUser } = useCurrentUserContext();

  return {
    energyBalance: currentUser?.energyBalance || [],
  };
};
